import request from '../utils/request';
import type { ApiResponse } from '@/types';

// ==================== 访客相关类型 ====================

/** 访客记录项 */
export interface VisitorRecord {
    id: number;
    ip: string;
    location: string;
    page_url: string;
    user_agent: string;
    visit_time: string;
}

/** 访客记录列表响应 */
export interface VisitorRecordListData {
    list: VisitorRecord[];
    pageNum: number;
    pageSize: number;
    total: number;
    totalPages: number;
}

/** 访客统计概览 */
export interface VisitStatsData {
    totalVisits: number;
    uniqueVisitors: number;
    todayVisits: number;
    todayUniqueVisitors: number;
    topPages: Array<{ page_url: string; visits: number; unique_visitors: number }>;
    topRegions: Array<{ location: string; visits: number; unique_visitors: number }>;
    dailyTrend: Array<{ day: string; visits: number; unique_visitors: number }>;
}

// ==================== 访客 API ====================

/**
 * 记录访客访问（通过 IP 自动获取归属地）
 * @param page_url 访问页面地址
 * @param user_agent 浏览器 UA 信息（可选）
 */
export const recordVisit = (
    page_url: string,
    user_agent?: string,
): Promise<ApiResponse<null>> => {
    return request.post('/visit/record', { page_url, user_agent }) as Promise<ApiResponse<null>>;
};

/**
 * 查询访客记录列表（需登录，支持分页筛选）
 * @param params 筛选参数
 */
export const getVisitRecords = (params: {
    page?: number;
    page_size?: number;
    ip?: string;
    page_url?: string;
    date_from?: string;
    date_to?: string;
}): Promise<ApiResponse<VisitorRecordListData>> => {
    return request.get('/visit/records', { params }) as Promise<ApiResponse<VisitorRecordListData>>;
};

/**
 * 获取访客统计概览
 */
export const getVisitStats = (): Promise<ApiResponse<VisitStatsData>> => {
    return request.get('/visit/stats') as Promise<ApiResponse<VisitStatsData>>;
};
